import { withSearch } from "@elastic/react-search-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import ResultSelectContext from "../../../providers/ResultSelectContext";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import nextafter from "nextafter";
import Select from "react-dropdown-select";

function FilterColumnRangeBar({ filters, setFilter, field, options }) {
  const { t } = useTranslation();
  const { setSelectedResultIds } = React.useContext(ResultSelectContext);

  const dropdownOptions = options.map((v, i) => {
    return {
      value: i,
      label: v,
    };
  });
  const minOption = options[0];
  const maxOption = options[options.length - 1];
  const [selectIndexes, setSelectIndexes] = React.useState([
    0,
    options.length - 1,
  ]);

  // Filter reset compatible code
  React.useMemo(() => {
    if (filters.length === 0) {
      setSelectIndexes([0, options.length - 1]);
    }
  }, [filters]);

  const updateIndex = (indexes) => {
    if (indexes[0] === selectIndexes[0] && indexes[1] === selectIndexes[1]) {
      return;
    }

    setSelectIndexes(indexes);
    setSelectedResultIds({});
    // Due to the specification of Elasticsearch, the same value as the maximum
    // value of the range filter is not retrieved. Since there is no way to get
    // the same value, we add a very small value.
    setFilter(field, {
      from: options[indexes[0]],
      to: nextafter(options[indexes[1]], Infinity),
    });
  };

  return (
    <div className="p-filter__list" style={{ overflow: "visible" }}>
      <div className="sui-range-slider-filter__slider">
        <Nouislider
          range={{ min: 0, max: options.length - 1 }}
          start={selectIndexes}
          connect
          step={1}
          onChange={(idxs) => updateIndex(idxs.map(Number))}
        />
        <ul>
          <li>{minOption}</li>
          <li>{maxOption}</li>
        </ul>
        <div className="sui-range-slider-filter__label_with_input">
          <label>Min</label>
          <Select
            values={[dropdownOptions[selectIndexes[0]]]}
            options={dropdownOptions.filter((v) => v.value <= selectIndexes[1])}
            onChange={(v) => updateIndex([v[0].value, selectIndexes[1]])}
          />
        </div>
        <div>to</div>
        <div className="sui-range-slider-filter__label_with_input">
          <label>Max</label>
          <Select
            values={[dropdownOptions[selectIndexes[1]]]}
            options={dropdownOptions.filter((v) => v.value >= selectIndexes[0])}
            onChange={(v) => updateIndex([selectIndexes[0], v[0].value])}
          />
        </div>
        <label>
          * {t("Range")} {minOption} - {maxOption}
        </label>
      </div>
    </div>
  );
}

export default withSearch(({ filters, setFilter }) => ({
  filters,
  setFilter,
}))(FilterColumnRangeBar);
